// Offset scroll position by the panel height so the browser doesn't
// scroll focused elements behind the sticky panel when navigating
// with the keyboard (addresses WCAG 2.4.11 - Focus Not Obscured)

const whatsOnFilters = document.querySelector('#app-whats-on');

if (whatsOnFilters) {
    const updateScrollPadding = () => {
        const height = whatsOnFilters.offsetHeight;

        // Expose panel height as a CSS custom property for use in layout
        // calculations elsewhere (e.g. positioning offsets, margin compensation)
        document.documentElement.style.setProperty('--sticky-panel-height', `${height}px`);

        // At large text sizes or high zoom levels the panel can grow tall enough
        // to obscure most of the viewport — fall back to relative positioning
        // above the threshold to keep content accessible
        document.body.classList.toggle('state--filters-oversized', height > 200 || height > window.innerHeight * 0.4);

    };

    // ResizeObserver fires whenever the panel's dimensions change, covering
    // font size changes, zoom, content updates, and viewport resizing
    new ResizeObserver(updateScrollPadding).observe(whatsOnFilters);

    // Run once on init before any resize events fire
    updateScrollPadding();
}


// WEBPACK FOOTER //
// ./src/js/whats-on-filters-sticky.js